module.exports = __webpack_public_path__ + "static/scale-model-of-love-wall-in-inglewood-california-d43e25a8deb61ac4264e0867177efdb4.png";